import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import {
  Calendar,
  Clock,
  Phone,
  Play,
  WebhooksLogo
} from '@phosphor-icons/react';

const TriggerNode = memo(({ data, selected }) => {
  const iconMap = {
    manual: Play,
    schedule: Clock,
    webhook: WebhooksLogo,
    phone_call: Phone,
    calendar_event: Calendar
  };

  const Icon = iconMap[data.triggerType] || Play;

  return (
    <div
      data-testid="flow-node-trigger"
      className={`
        group relative min-w-[190px] max-w-[230px] rounded-[10px] overflow-hidden
        bg-[var(--surface-2)] border-l-[3px] border transition-all duration-150
        ${selected
          ? 'border-l-pink-400 border-[var(--border-strong)]'
          : 'border-l-pink-500 border-[var(--border-default)] hover:border-[var(--border-strong)]'}
      `}
    >
      {/* Header */}
      <div className="flex items-center gap-2.5 px-3 pt-3 pb-2">
        <div className="flex-shrink-0 w-[34px] h-[34px] rounded-lg bg-pink-500/10 border border-pink-500/20 flex items-center justify-center">
          <Icon size={20} weight="duotone" className="text-pink-400" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-white truncate leading-tight">{data.label || 'Trigger'}</p>
          <span className="text-[10px] text-pink-400/60 font-medium uppercase tracking-wider">Trigger</span>
        </div>
      </div>

      {/* Body */}
      <div className="px-3 pb-2.5 pt-0.5 border-t border-white/[0.04]">
        <span className="text-[10px] text-slate-500 capitalize">
          {data.triggerType?.replace(/_/g, ' ') || 'Event'}
        </span>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        className="!w-[10px] !h-[10px] !border-2 !right-[-6px] transition-colors
          !bg-pink-400 !border-pink-300/50 hover:!bg-pink-300"
      />
    </div>
  );
});

TriggerNode.displayName = 'TriggerNode';
export default TriggerNode;
